module.exports = __webpack_public_path__ + "static/img/80W-1.27d15fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/image/06/80W-1.png
// module id = m9KG
// module chunks = 2